export function normalizeCharityPlans(plans) {
  return (plans || [])
    .filter((plan) => plan.slug !== 'test' && Number(plan.id) !== 6)
    .map((plan) => {
      const custom = plan.slug === 'custom' || Number(plan.id) === 8
      const prepaid = Array.isArray(plan.prepaid_years) && plan.prepaid_years.length ? plan.prepaid_years : null
      return {
        ...plan,
        prepaid_years: prepaid || (custom ? [2, 3, 4] : null),
        setup_fee_label: plan.setup_fee_label || (custom ? '£947.97 one-time, then the yearly plan' : null),
      }
    })
}

export function planId() {
  return String(sessionStorage.getItem('chgamsSubscription') ?? '')
}

export function isAgencyAccount() {
  const type = String(sessionStorage.getItem('reg_type') || '').toLowerCase()
  return type === 'agent' || Boolean(sessionStorage.getItem('agency_id'))
}

export function canBulkUploadDonations() {
  if (isAgencyAccount()) {
    return ['1', '2', '3'].includes(planId())
  }
  return planId() === '5'
}

export function canBulkUploadMembers() {
  if (isAgencyAccount()) {
    return planId() !== '' && planId() !== '0'
  }
  return !['', '0', '1', 'null'].includes(planId())
}

export function memberUploadLimit() {
  if (isAgencyAccount()) {
    return ['1', '2', '3'].includes(planId()) ? 100 : 50
  }
  return planId() === '5' ? 500 : 70
}
